/**
 * O hambúrguer que abre a navegação — e que só existe quando ela está escondida.
 *
 * Vive aqui e não dentro do `ChatView` porque há DOIS cabeçalhos de topo (o do
 * canal e o dos amigos) e ambos precisam dele. Duas cópias de um botão que fala
 * com a store é o género de duplicação que envelhece mal: a primeira vez que o
 * ícone ou o rótulo mudassem, um dos dois ficava para trás.
 *
 * Devolve `null` no desktop em vez de se esconder por CSS. A rail e a barra de
 * canais estão lá, visíveis, sempre — um botão para "abrir" o que já está aberto
 * seria mentira para quem lê o ecrã com um leitor.
 */

import { useIsMobile } from "../lib/media";
import { useStore } from "../store/store";
import { IconMenu } from "./Icons";

export function MenuButton() {
  const mobile = useIsMobile();
  const navOpen = useStore((s) => s.navOpen);
  const toggleNav = useStore((s) => s.toggleNav);

  if (!mobile) return null;

  return (
    <button
      type="button"
      className="icon-button chat__menu"
      onClick={toggleNav}
      aria-expanded={navOpen}
      aria-controls="app-nav"
      aria-label="Servidores e canais"
      title="Servidores e canais"
    >
      <IconMenu size={20} />
    </button>
  );
}
